'use es6';

import { PopoverType } from '../../constants/popover';
import PersonalizePopoverBody from './PersonalizePopoverBody';
import { jsx as _jsx } from "react/jsx-runtime";
function PersonalizePopoverBodyEditLegacy(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-edit",
    children: /*#__PURE__*/_jsx(PersonalizePopoverBody, Object.assign({}, props, {
      type: PopoverType.EDIT
    }))
  });
}
PersonalizePopoverBodyEditLegacy.displayName = 'PersonalizePopoverBodyEditLegacy';
export default PersonalizePopoverBodyEditLegacy;